<template>
  <div class="dashboard">
    <header>
      <h1 class="logo">Welcome to Dashboard</h1>
      <nav class="header-nav">
        <router-link to="/dashboard/profile" class="profile-link">
          Profil
        </router-link>
        <button @click="handleLogout" class="logout-btn">
          Logout
        </button>
      </nav>
    </header>

    <div class="dashboard-content">
      <!-- Sidebar with collapse functionality -->
      <aside :class="['sidebar', { collapsed: isSidebarCollapsed }]">
        <button @click="toggleSidebar" class="sidebar-toggle">
          ☰
        </button>
        <nav>
          <a href="/dashboard" class="sidebar-link">Home</a>
        </nav>
      </aside>

      <!-- Main Content -->
      <main class="main-content">
        <router-view />
      </main>
    </div>

    <footer>
      <p>All rights reserved © 2025</p>
    </footer>
  </div>
</template>
  
<script>
import { mapActions } from 'vuex';

export default {
  name: 'UserDashboard',
  data() {
    return {
      isSidebarCollapsed: true,
    };
  },
  methods: {
    ...mapActions(['logout']),
    handleLogout() {
      this.logout();
      this.$router.push('/login'); // Redirect to login page
    },
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    },
  },
};
</script>

  
  <style scoped>
  /* Genel Dashboard Tasarımı */
  .dashboard {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  
  /* Üst Menü */
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #2c3e50;
    padding: 10px 20px;
    color: white;
  }
  
  .logo {
    font-size: 1.5rem;
    font-weight: bold;
  }
  
  .header-nav {
    display: flex;
    gap: 15px;
    align-items: center;
  }
  
  .profile-link, .logout-btn {
    color: white;
    text-decoration: none;
    background: none;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .profile-link:hover, .logout-btn:hover {
    text-decoration: underline;
  }
  
  /* İçerik Bölümü */
  .dashboard-content {
    display: flex;
    flex: 1;
  }
  
  /* Sol Menü */
  .sidebar {
    background-color: #34495e;
    width: 200px;
    padding: 20px;
    color: white;
    transition: width 0.3s;
  }
  
  .sidebar ul {
    list-style: none;
    padding: 0;
  }
  
  .sidebar li {
    margin-bottom: 15px;
  }
  
  .sidebar a {
    color: white;
    text-decoration: none;
    font-size: 1.1rem;
  }
  
  .sidebar a:hover {
    text-decoration: underline;
  }
  
  /* Ana İçerik */
  .main-content {
    flex: 1;
    padding: 20px;
    background-color: #ecf0f1;
    overflow-y: auto;
  }
  
  /* Footer */
  footer {
    background-color: #2c3e50;
    color: white;
    text-align: center;
    padding: 10px;
  }
  
  /* Mobil Uyumlu Tasarım */
  @media (max-width: 768px) {
    .dashboard-content {
      flex-direction: column;
    }
  
    .sidebar {
      width: 100%;
      text-align: center;
      padding: 10px;
    }
  
    .sidebar ul {
      display: flex;
      justify-content: center;
      gap: 15px;
    }
  
    .header-nav {
      flex-direction: column;
      gap: 5px;
    }
  
    .logout-btn {
      font-size: 0.9rem;
    }
  
    .language-selector {
    padding: 5px;
    margin-right: 15px;
    border-radius: 4px;
    border: 1px solid #fff;
    background: transparent;
    color: white;
    cursor: pointer;
  }
  
  .language-selector option {
    background: #2c3e50;
    color: white;
  }
  }

  /* Dashboard Layout */
.dashboard {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

/* Header */
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #2c3e50;
  padding: 10px 20px;
  color: white;
}

.logo {
  font-size: 1.5rem;
  font-weight: bold;
}

.header-nav {
  display: flex;
  gap: 15px;
  align-items: center;
}

.profile-link, .logout-btn {
  color: white;
  text-decoration: none;
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
}

.profile-link:hover, .logout-btn:hover {
  text-decoration: underline;
}

/* Dashboard Content */
.dashboard-content {
  display: flex;
  flex: 1;
}

/* Sidebar */
.sidebar {
  background-color: #34495e;
  width: 200px;
  padding: 20px;
  color: white;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
}

/* Collapsed Sidebar */
.sidebar.collapsed {
  width: 50px;
  padding: 10px;
}

/* Sidebar Toggle Button */
.sidebar-toggle {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  margin-bottom: 20px;
  align-self: flex-start;
}

/* Hide text when sidebar is collapsed */
.sidebar.collapsed .sidebar-link {
  display: none;
}

/* Main Content */
.main-content {
  flex: 1;
  padding: 20px;
  background-color: #ecf0f1;
  overflow-y: auto;
}

/* Footer */
footer {
  background-color: #2c3e50;
  color: white;
  text-align: center;
  padding: 10px;
}

  </style>
  